import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-745d2d35"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "cm-align-center",
  style: {"cursor":"pointer"}
}
const _hoisted_3 = {
  t: "1784253877323",
  style: {"color":"#f0a443","font-weight":"bold","font-size":"17px","margin-right":"4px"},
  width: "17px",
  height: "17px",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6877"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M512 853.333333a341.333333 341.333333 0 1 0 0-682.666666 341.333333 341.333333 0 0 0 0 682.666666z m0 85.333334C276.352 938.666667 85.333333 747.648 85.333333 512S276.352 85.333333 512 85.333333s426.666667 191.018667 426.666667 426.666667-191.018667 426.666667-426.666667 426.666667z m-42.666667-256h85.333334v85.333333h-85.333334v-85.333333z m0-426.666667h85.333334v341.333333h-85.333334V256z",
  fill: "#f0a443",
  "p-id": "6878"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { style: {"color":"#f0a443"} }
const _hoisted_7 = { class: "cm-ui-bold-txt" }

import { reactive, ref, computed, PropType, onMounted, nextTick } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import {
  PortViewService,
  BlockRuleParams,
  QueryParams as PortQueryParams,
  PortItem as PortViewItem,
} from '../port-view/port-view.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
import {
  FormSize,
  FormType,
  ObjectFormItem,
} from '@/components/cmForm/types'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { TableViewMode, TableViewModeType } from '@/views/dashboard/_enum/table-view-mode'
import { TerminalTypeOptions } from '@/views/dashboard/_enum/terminal-type'
import { ServicePermissionService, PermissionFe } from '@/services/service-permission.service'
import { getRiskPortDisplayText } from '@/utils/port-risk-display'

type PortColumnSlot = { value: number; row: PortViewItem; column?: unknown; index?: number }

type PortFilterFormKeys = Extract<keyof PortQueryParams, 'system_type' | 'is_risk_port'>

export default /*#__PURE__*/_defineComponent({
  __name: 'port-list-top10',
  props: {
  viewMode: {
    type: String as PropType<TableViewModeType>,
    default: TableViewMode.preview
  },
  /** 打开「全部端口」抽屉时由饼图等带入，对应接口 is_risk_port：1 风险，2 未知 */
  initialIsRiskPort: {
    type: Number as PropType<1 | 2 | undefined>,
    default: undefined
  },
  /** 风险 TOP5 ：端口号写入列表搜索关键字 */
  initialPortKeyword: {
    type: String,
    default: ''
  },
},
  emits: ['viewAll', 'blockPort'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t, te, locale } = useI18n()

function riskPortTop10RowDetail (row: PortViewItem) {
  return getRiskPortDisplayText(t, te, row.port_num, row.system_type, row.risk_detail)
}

const props = __props

const emits = __emit

const injector = useReflectiveInjector()
const portViewService = injector.get(PortViewService)
const servicePermissionService = injector.get(ServicePermissionService)
const dataApi = portViewService.getPortList.bind(portViewService)
const hasPermission = servicePermissionService.getHasPermission(PermissionFe.port_control)

const tableRef = ref()

const { refreshList } = useCmTableListRefresh(tableRef)
const queryParams = reactive<Partial<PortQueryParams>>({
  page: 1,
  limit: props.viewMode === TableViewMode.preview ? 10 : 20,
  key_word: props.initialPortKeyword || '',
  system_type: undefined,
  is_risk_port: props.initialIsRiskPort,
  asc: true,
  sort: 'port_num'
})
const selectedRows = ref<PortViewItem[]>([])

const filterFormColumns = computed<ObjectFormItem<PortQueryParams, PortFilterFormKeys>>(() => {
  void locale.value
  return {
    system_type: {
      colOpt: { style: 'width: 150px;flex: 0 0 auto' },
      label: t('portManage.systemType'),
      type: FormType.Select,
      dictData: TerminalTypeOptions,
      outSearchFiledFlag: true,
      hiddenAllLabel: true,
      selectOpt: {
        clearable: true,
      },
      events:{
        change: () => handleQuery()
        }
    },
    is_risk_port: {
      colOpt: { style: 'width: 120px;flex: 0 0 auto' },
      label: t('portManage.riskRef'),
      type: FormType.Select,
      dictData: [
        { label: t('portManage.risk'), value: 1 },
        { label: t('portManage.unknown'), value: 2 }
      ],
      outSearchFiledFlag: true,
      hiddenAllLabel: true,
      selectOpt: {
        clearable: true,
      },
      events:{
        change: () => handleQuery()
        }
    },
  }
})

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    isLink: true,
    columnOpt: { label: t('portManage.operation'), width: 100, align: 'left', fixed: 'right' },
    actionButtons: (rowItem: PortViewItem) => [
      {
        name: t('portManage.block'),
        type: 'block',
        opt: { size: FormSize.Small, type: 'primary' },
        content: t('safeProtectionModule.tooltipLinuxNoSupport'),
        disabledTooltip: !isLinuxSystem(rowItem),
        disabled: () => isLinuxSystem(rowItem),
        events: {
          click() {
            handleBlockPort(rowItem)
          }
        }
      },
    ],
  }
})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : 'background: transparent;padding:0',
    containerOpt: { style: 'padding: 0;background: var(--cm-color-card-bg)' },
    path: 'list',
    height: props.viewMode === TableViewMode.preview ? undefined : '100%',
    showActionBar: false,
    showForm: false,
    showRightToolbar: false,
    rowKey: (row: PortViewItem) => `${Number(row.system_type)}_${Number(row.port_num)}`,
    selection: true,
    selectable: (row: PortViewItem) => !isLinuxSystem(row),
    showTip: false,
    usePagination: false,
    disableScrollLoad: props.viewMode === TableViewMode.preview,
    scrollLoadThreshold: 10,
    scrollLoadDelay: 100,
    columns: [
      {
        label: t('portManage.portNum'),
        prop: 'port_num',
        sortable: true,minWidth:120,
      },
      {
        label: t('portManage.systemType'),
        prop: 'system_type',
        sortable: true,minWidth:120,
      },
      {
        label: t('ipAccessEvent.protocol'),
        prop: 'protocol',minWidth:120,
      },
      {
        label: t('portManage.listenProcessName'),
        prop: 'process_name',minWidth:120,
      },
      {
        label: t('portManage.riskRef'),
        prop: 'risk_reference',minWidth:120,
      },
      {
        label: t('portManage.deviceCount'),
        prop: 'device_count',minWidth:120,
        sortable: true,
      },
    ],
  }
})

function getSystemTypeLabel(systemType: number): string {
  if (systemType === 1) return 'Windows'
  if (systemType === 2) return 'Linux'
  if (systemType === 3) return 'WinServer'
  return '--'
}

function isLinuxSystem(row: PortViewItem): boolean {
  return Number(row.system_type) === 2
}

async function handleSearch(value: string) {
  await nextTick()
  queryParams.key_word = value
  void refreshList()
}

async function handleQuery() {
  await refreshList()
}

function handleReset() {
  queryParams.key_word = props.initialPortKeyword || ''
  queryParams.system_type = undefined
  queryParams.is_risk_port = props.initialIsRiskPort
  void refreshList()
}

function handleBlockPort(row: PortViewItem) {
  emits('blockPort', row)
}

function handleSelectionChange(rows: PortViewItem[]) {
  selectedRows.value = rows
}

async function handleBatchBlock() {
  const blockable = selectedRows.value.filter((row) => !isLinuxSystem(row))
  if (!blockable.length) return
  try {
    const params: BlockRuleParams = {
      select_type: 2,
      port_start: blockable[0].port_num,
      port_end: blockable[0].port_num,
      system_types: [...new Set(blockable.map((r) => r.system_type))],
      port_list: blockable.map((r) => ({ port: r.port_num, system_type: r.system_type })),
    }
    await portViewService.addBlockRule(params)
    ElMessage.success(t('portManage.blockSuccess'))
    selectedRows.value = []
    ;(tableRef.value as any)?.tableRef?.clearSelection?.()
    await refreshList()
  } catch {
    ElMessage.error(t('portManage.blockFailed'))
  }
}

function handleAction({ type }: { type: any }) {
  // Handle actions
}

onMounted(async () => {
  if (!hasPermission) return
  await refreshList()
})

__expose({
  tableRef,
  getList: () => void refreshList(),
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    tableOpt: tableOpt.value,
    tableActOpt: tableActOpt.value,
    firstLoading: false,
    "has-permission": _unref(hasPermission),
    api: _unref(dataApi),
    modelValue: queryParams,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams) = $event)),
    pageOption: {
      style: 'padding-bottom: 16px',
      pageNumName: 'page',
      pageSizeName: 'limit',
    },
    onHandleAction: handleAction,
    onChangeSelected: handleSelectionChange
  }, {
    header: _withCtx(() => [
      _createVNode(SearchFilterBar, {
        modelValue: queryParams,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams) = $event)),
        "sync-search-from-field": "key_word",
        "form-columns": filterFormColumns.value,
        disabled: !_unref(hasPermission),
        "show-search": true,
        "search-placeholder": _ctx.$t('portManage.portNum'),
        "popover-threshold": 2,
        onSearch: handleSearch,
        onQuery: handleQuery,
        onReset: handleReset
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            plain: "",
            disabled: !selectedRows.value.length,
            onClick: handleBatchBlock
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('portManage.batchBlock')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          (props.viewMode === _unref(TableViewMode).preview)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "small",
                disabled: !_unref(hasPermission),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewAll')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"])
    ]),
    system_type: _withCtx((slotProps) => [
      _createElementVNode("span", null, _toDisplayString(getSystemTypeLabel((slotProps as PortColumnSlot).value)), 1)
    ]),
    device_count: _withCtx((slotProps) => [
      _createVNode(_component_el_tooltip, {
        content: _unref(t)('safeProtectionModule.tooltipLinuxNoSupport'),
        placement: "top",
        disabled: !isLinuxSystem((slotProps as PortColumnSlot).row)
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, [
            _createVNode(_component_el_button, {
              type: "text",
              disabled: isLinuxSystem((slotProps as PortColumnSlot).row),
              onClick: ($event: any) => (handleBlockPort((slotProps as PortColumnSlot).row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString((slotProps as PortColumnSlot).row.device_count), 1)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ])
        ]),
        _: 2
      }, 1032, ["content", "disabled"])
    ]),
    risk_reference: _withCtx((slotProps) => [
      (!(slotProps as PortColumnSlot).row.is_known_risk)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('portManage.unknown')), 1))
        : (_openBlock(), _createBlock(_component_el_popover, {
            key: 1,
            placement: "bottom-start",
            width: 380,
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('portManage.risk')), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('portManage.riskLabel')), 1),
                _createTextVNode(_toDisplayString(riskPortTop10RowDetail((slotProps as PortColumnSlot).row)), 1)
              ])
            ]),
            _: 2
          }, 1024))
    ]),
    _: 1
  }, 8, ["tableOpt", "tableActOpt", "has-permission", "api", "modelValue"]))
}
}

})